<app-okr-toolbar-bare [fixedPosition]="true">
  <span class="spacer"></span>
  <button (click)="openPlayground()" class="button-bag-layout"
          mat-stroked-button>{{ 'demo-main-view.playground' | translate }}</button>
</app-okr-toolbar-bare>
<div class="placeholder"></div>
<router-outlet></router-outlet>
<app-scroll-top></app-scroll-top>
